const JournalPillTypes = {
  JOURNAL: 'JOURNAL',
  LOCAL_JOURNAL: 'LOCAL_JOURNAL',
  JOURNALS_DETAIL: 'JOURNALS_DETAIL',
  CALCUATION_LOG: 'CALCUATION_LOG',
};

export default JournalPillTypes;
